import React, { useContext, useEffect, useState } from 'react'
import icon from '../../../assets/BusinessInfoIcon.png'
import { Button, Card, Spinner, TextInput, Textarea } from 'flowbite-react'
import * as styles from './businessInfo.styles'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import uploadIcon from '../../../assets/uploadIcon.png'
import CustomButton from '../../../components/CustomButton/CustomButton'
import { FaArrowRight } from 'react-icons/fa'
import FileUploadCard from '../../../components/FileUploadCard/FileUploadCard'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../../contexts/UserContext'

const BusinessInfo = ({ changeCard }: any) => {
    const { userDetails } = useContext(UserContext) ?? {}
    const [businessInfo, setBusinessInfo] = useState<any>()
    const [loading, setLoading]= useState<boolean>(false)


    const [formData, setFormData] = useState({
        description: '',
        emailAddress: '',
        phoneNumber: '',
        businessAddress: '',
        city: '',
        state: '',
        logo: null,
        website: '',
        facebookLink: '',
        xLink: '',
        instagramLink: '',
        logoUrl: ''
    })


    useEffect(() => {
        const fetchData = async () => {
            await getBusinessInfo()
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (businessInfo) {
            setFormData({
                description: businessInfo?.description ?? '',
                emailAddress: businessInfo?.supportEmail ?? '',
                phoneNumber: businessInfo?.mobileNumber ?? '',
                businessAddress: businessInfo?.address ?? '',
                city: businessInfo?.city ?? '',
                state: businessInfo?.state ?? '',
                logo: businessInfo?.logo ?? null,
                website: businessInfo?.website ?? '',
                facebookLink: businessInfo?.facebook ?? '',
                xLink: businessInfo?.twitter ?? '',
                instagramLink: businessInfo?.instagram ?? '',
                logoUrl: businessInfo?.logo ?? ''
            });
        }
    }, [businessInfo]);

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileInputChange = (file: File | null, fileType: string) => {

        let logoUrl = file ? URL.createObjectURL(file) : ''
        setFormData({
            ...formData,
            [fileType]: file,
            logoUrl: logoUrl
        });
    };
    const navigate = useNavigate()

    const handleSubmit = async () => {
        setLoading(true)
        const formDataToSend = new FormData();
        formDataToSend.append("Description", formData.description);
        formDataToSend.append("EmailAddress", formData.emailAddress);
        formDataToSend.append("MobileNumber", formData.phoneNumber);
        formDataToSend.append("Address", formData.businessAddress);
        formDataToSend.append("City", formData.city);
        formDataToSend.append("State", formData.state);
        if (formData.logo) {
            formDataToSend.append("SubsidiaryLogo", formData.logo);
        }
        formDataToSend.append("Website", formData.website);
        formDataToSend.append("Facebook", formData.facebookLink);
        formDataToSend.append("Instagram", formData.instagramLink);
        formDataToSend.append("Twitter", formData.xLink);


        try {
            const response = await client.post("/subsidiary/dashboard/onboarding/business/information", formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status === "success") {
                console.log(response);

                showToast(response.data.message, "success")
                if (userDetails.activeSubsidiary.businessType == "Individual") {
                    navigate('/business/onboarding/kyc/bank-details')
                    window.location.reload()
                    localStorage.setItem('activeCard', 'Bank Details')
                }
                else {
                    navigate('/business/onboarding/kyc/business-registration')
                    window.location.reload()
                    localStorage.setItem('activeCard', 'business Reg')
                }
            } else {
                console.log(response.data.message);
                showToast(response.data.message, "error")
            }
        } catch (err: any) {
            console.error('Error saving business details', err);
            showToast(err.response.data.message, "error")
        }
        finally{
            setLoading(false)
        }


    }

    const getBusinessInfo = async () => {
        try {
            const response = await client.get("/subsidiary/dashboard/onboarding/business/information/view");
            console.log(response.data.data);

            setBusinessInfo(response.data.data)
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
                showToast(err, "error");
            }
        }
    };


    return (
        <div className={styles.container}>
            <img src={icon} className={styles.icon} />
            <div>
                <p className={styles.sectionTitle}>Business Information</p>
                <p className={styles.sectionSubtitle}>Kindly provide us with some business information to get your dashboard ready</p>
            </div>
            <div className={styles.inputContainer}>
                <p className={styles.inputLabel}>What do you do at {userDetails.activeSubsidiary.businessName}?</p>
                <p className={styles.inputHint}>For example, Ideospay limited sells different types of shoes, slippers, sandals and bags on our instagram and website.</p>
                <Textarea className={styles.textArea} value={formData.description} name='description' onChange={handleInputChange} />
            </div>
            <div className={styles.inputContainer}>
                <CustomInput label="Business email" value={formData.emailAddress} name='emailAddress' placeholder='Enter email' onChange={handleInputChange} />
            </div>
            <div className={styles.inputContainer}>
                <CustomInput label="Business phone number" value={formData.phoneNumber} name='phoneNumber' placeholder='Enter phone number' onChange={handleInputChange} />
            </div>
            <div className={styles.inputContainer}>
                <CustomInput label="Business address" value={formData.businessAddress} name='businessAddress' placeholder='Enter business address' onChange={handleInputChange} />
            </div>
            <div className={`${styles.inputContainer} ${styles.gridContainer}`}>
                <div>
                    <CustomInput label="City" name='city' value={formData.city} placeholder='Enter city' onChange={handleInputChange} />
                </div>
                <div>
                    <CustomInput label="State" name='state' value={formData.state} placeholder='Enter state' onChange={handleInputChange} />
                </div>
            </div>
            <div className={styles.inputContainer}>
                <CustomInput label="Business Website" value={formData.website} name='website' placeholder='https://' onChange={handleInputChange} />

            </div>
            <div className={styles.inputContainer}>
                <p className={styles.textInputLabel}>Business Logo <span className='text-sm font-normal'>(Optional)</span></p>
                <div className={styles.businessLogoContainer}>
                    {formData.logoUrl && (
                        <div className={styles.businessLogo}>
                            {/* <p className={styles.businessLogoText}>T</p> */}
                            <img src={formData.logoUrl} alt='Business Logo' className='w-full h-full object-cover' />
                        </div>)}
                    <div className={styles.cardContainer}>
                        <FileUploadCard
                            label=''
                            onChange={(file) => handleFileInputChange(file, 'logo')}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.socialMediaContainer}>
                <CustomInput label='Facebook' name='facebookLink' value={formData.facebookLink} onChange={handleInputChange} />
                <CustomInput label='Instagram' name='instagramLink' value={formData.instagramLink} onChange={handleInputChange} />
                <CustomInput label='X(Twitter)' name='xLink' value={formData.xLink} onChange={handleInputChange} />
                <CustomInput label='Tiktok' name='tiktok' />
            </div>
            <div className={styles.buttonContainer}>
                <CustomButton onClick={() => handleSubmit()} text={loading?<Spinner/>:'Save Details'} icon={loading?'':<FaArrowRight />} className={styles.button} />
            </div>
        </div>
    )
}

export default BusinessInfo
